import type { ReactNode } from 'react';
import { Typography, useTheme } from '@mui/material';

import { theme as tgTheme } from '@theguarantors/tg-package-material-ui';

export const fieldHelperTextSx = {
  color: tgTheme.palette.neutralGrey[600],
  fontFamily: tgTheme.typography.fontFamily,
  fontSize: '12px',
  fontWeight: 400,
  letterSpacing: '-0.16px',
  lineHeight: '20px',
  margin: '3px 12px 0 12px',
  '&.Mui-error': {
    color: 'error.dark',
  },
  '&.Mui-disabled': {
    color: tgTheme.palette.neutralGrey[300],
  },
} as const;

type FieldHelperTextProps = {
  text?: ReactNode;
  disabled?: boolean;
  error?: boolean;
  dataTestId?: string;
};

export const FieldHelperText = ({
  text,
  disabled = false,
  error = false,
  dataTestId,
}: FieldHelperTextProps) => {
  const theme = useTheme();

  const color = disabled
    ? tgTheme.palette.neutralGrey[300]
    : error
      ? theme.palette.error.main
      : tgTheme.palette.neutralGrey[600];

  return (
    <Typography
      data-testid={dataTestId}
      variant="helpertext"
      sx={{
        ...fieldHelperTextSx,
        color,
      }}
    >
      {text}
    </Typography>
  );
};
